

import { Tooltip, Typography } from 'antd'
import { Balloon } from '@alifd/next';
import React from 'react';
import styles from './style.module.scss'
// import './style.scss'
const { Paragraph } = Typography;


const DarkToolTip = (props): JSX.Element => {

  const { triggerContent, content, empty = "", maxRow = 2, padding = '16px', lineCount, ...others } = props

  const parentDivRef = React.useRef(null)
  return content ?

    <Balloon.Tooltip
      v2
      align='r'
      trigger={<span style={{ ["--line-count"]: lineCount || 2 }} className={styles.ellipsis}>{triggerContent}</span>}
    >
      <div style={{
        fontSize: 12,
        fontWeight: 400,
        color: "#FFFFFF",
        letterSpacing: '0.4px',
        textAlign: 'left',
        lineHeight: "20px",
        maxHeight: 200,
        maxWidth: 400,
        overflowY: "auto",
        scrollbarWidth: "none",

      }}>
        {content}
      </div>
    </Balloon.Tooltip>
    : empty
}

export default DarkToolTip;